import { Box, Dialog, Paper, Stack, styled } from "@mui/material";
import { InternalButtonLink } from "../InternalButtonLink";
import { toPx } from "../MuiHelpers";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";

export const LinkButton = styled(InternalButtonLink)(({ theme }) =>
    theme.unstable_sx({
        textTransform: "none",
        textAlign: "center",
        minHeight: 74,
        flexDirection: "column",
        justifyContent: "flex-start",
        width: "33.333%",
        padding: `${theme.spacing(3)} ${theme.spacing(3)} 0 ${theme.spacing(3)}`,
        [theme.breakpoints.up("md")]: {
            maxWidth: "unset",
            padding: `${theme.spacing(4)} ${theme.spacing(3)} 0 ${theme.spacing(3)} `,
            minHeight: 94,
        },
        color: theme.palette.common.white,
        background: `linear-gradient(127.06deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
        margin: 0,
        ".MuiButton-startIcon": {
            margin: 0,
            marginTop: 0,
            height: 24,
            alignItems: "center",
        },
        "&.Mui-disabled": {
            background: theme.palette.grey.softDark,
        },
    }),
);

export const StepperCustomStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        height: "100%",
    }),
);

export const StepperInvisibleBox = styled(
    Box,
    styledOmitPropsOptions,
)(({ theme }) =>
    theme.unstable_sx({
        display: "none",
    }),
);

export const StepperCustomPaper = styled(Paper)<{ width: number | string }>(({ theme, width }) =>
    theme.unstable_sx({
        width: toPx(width) ?? "100%",
        height: "90vh",
        maxHeight: "700px",
        overflow: "hidden",
    }),
);

export const StepperCustomDialog = styled(Dialog)(({ theme }) =>
    theme.unstable_sx({
        "& .MuiDialog-container": {
            alignItems: { xs: "end", md: "center" },
        },
    }),
);
